import React from 'react';
import { Form, FormGroup, Label, Input, Button } from 'reactstrap';
import apiclient from 'lib/apiclient';
import { useFormik, Form as FormikForm, Field} from 'formik';

export default () => {
  const handleFileCreationFailedList = React.useCallback(() => {
    apiclient.download('api/management/filecreationfailedlist')
  }, []);

  const handleDocumentIds = React.useCallback(() => {
    apiclient.download('api/management/documentids')
  }, []);

  const handleUpdateDocumentIds = React.useCallback(() => {
    apiclient.download('api/management/updatedocumentids')
  }, []);

  const handleView = React.useCallback((values) => {
    apiclient.get(`api/user/${values.email}`).then((response) => {
      setState(response.data);
      setRead(true);
    }).catch(() => {
      setState(null);
      setRead(true);
    });
  }, []);

  const handleVerify = React.useCallback((formikValues, responseData) => {
    apiclient.post('api/user/verify', {
      uid: responseData.uid,
      special: formikValues.special})
    .then(() => {
      alert("認証状態の変更に成功しました。")
      handleView(responseData);
    })
    .catch(() => {
      alert("認証状態の変更に失敗しました。")
    });
  }, []);

  const handleDelete = React.useCallback((formikValues, responseData) => {
    apiclient.post('api/user/delete', {
      uid: responseData.uid,
      special: formikValues.special
    })
      .then(() => {
        alert("ユーザーの削除に成功しました。")
        handleView(responseData);
      })
      .catch(() => {
        alert("ユーザーの削除に失敗しました。")
      });
  }, []);

  const [read, setRead] = React.useState(false);
  const [state, setState] = React.useState();

  const formik = useFormik({
    initialValues: {email: '', special: ''}
  });

  return (
    <div>
      <h1>管理ツール</h1>
      <p><Button onClick={handleFileCreationFailedList}>PDF作成失敗CSVファイルダウンロード</Button></p>
      <p><Button onClick={handleDocumentIds}>全ドキュメントID一覧CSVファイルダウンロード</Button></p>
      <p><Button onClick={handleUpdateDocumentIds}>ドキュメント更新用ID一覧CSVファイルダウンロード</Button></p>
      <hr style={{borderTop: "3px solid #bbb"}} />
      <h3>メールアドレス承認ツール</h3>
      <Form>
        <FormGroup>
          <Label for="email">メールアドレス</Label>
          <Input id="email" name="email" type="email"
            placeholder="メールアドレス" 
            onChange={formik.handleChange}
            value={formik.values.email}
          />
        </FormGroup>
        <Button onClick={() => handleView(formik.values)}>参照</Button>
        {read ? 
          state ? 
          <React.Fragment>
            <hr style={{borderTop: "1px solid #bbb"}} />
            <p>メールアドレス:{state.email}</p>
            <p>ステータス:{state.disabled ? "無効" : "有効"}</p>
            <p>ユーザー名:{state.displayName}</p>
            <p>認証状態:{state.emailVerified ? "認証済み" : "認証待ち"}</p>
            <React.Fragment>
              <hr style={{ borderTop: "1px solid #bbb" }} />
              <FormGroup>
                <Label for="special">スペシャル</Label>
                <Input id="special" name="special" placeholder="機能を利用するための秘密のパスワード"
                  onChange={formik.handleChange}
                  value={formik.values.special}
                />
              </FormGroup>
                {!state.emailVerified ?
                  <p><Button onClick={() => handleVerify(formik.values, state)}>メールアドレスを認証済みに変更します</Button></p> : null}
              <p><Button onClick={() => handleDelete(formik.values, state)}>メールアドレスを削除します</Button></p>
            </React.Fragment>
          </React.Fragment> : <h4>ユーザーが見つかりません</h4> : null
        }
      </Form>
    </div>
  );
}